export default function onSearchClearCustomerList() {
    return (dispatch) => {
    dispatch(clear());
  }
}

function clear() {
    return {
      type: 'clearCustomerList',
      payload: {},
    };
  }